import { Component, Input, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { GenericValue, HisAuthService } from 'hisng';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-edit-classification-tab',
    templateUrl: './patent-edit-classification-tab.component.html',
    providers: [ProviderManager.getComponentProvider(PatentEditClassificationTabComponent)],
} )
export class PatentEditClassificationTabComponent {
    @Input() patent: Patent;
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    constructor( public auth: HisAuthService ) { }

    /**
     * Implementation of EventEmitter method from research-area-plam to set researchAreas array.
     *
     * @param event the selected researchAreas
     */
    selectedResearchAreasChange( event: GenericValue[] ) {
        this.patent.researchAreas = event;
    }

    /**
     * Implementation of EventEmitter method from subject-area-plam to set subjectAreas array.
     *
     * @param event the selected subjectAreas
     */
    selectedSubjectAreasChange( event: GenericValue[] ) {
        this.patent.subjectAreas = event;
    }
}
